// V_WOOD_SITE_07 | 10% Shipping Fee at Checkout vs Free Shipping
// Var A: "Free shipping" becomes "Fast shipping" sitewide, "Shipping calculated at checkout"
// shows under the GemPages Add to Cart and the UpCart checkout button, and the UpCart
// trust badge image is swapped for a "Lifetime guarantee + Fast shipping" text strip.
// UpCart renders in a shadow root, so it is watched separately and gets this CSS file linked in.
(function () {
  var NOTE = "Shipping calculated at checkout";
  // Lock icon exported from Figma (13x16)
  var LOCK_ICON =
    '<svg width="13" height="16" viewBox="0 0 13 16" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M2.30952 6.47619H10.6905C11.5321 6.47619 12.2143 7.15842 12.2143 8V13.7143C12.2143 14.5559 11.5321 15.2381 10.6905 15.2381H2.30952C1.46795 15.2381 0.785714 14.5559 0.785714 13.7143V8C0.785714 7.15842 1.46795 6.47619 2.30952 6.47619Z" stroke-width="1.06667" stroke="black"/>' +
    '<path d="M3.3 6.47619V4.11429C3.3 3.26559 3.63714 2.45166 4.23726 1.85154C4.83737 1.25143 5.65131 0.914286 6.5 0.914286C7.34869 0.914286 8.16263 1.25143 8.76274 1.85154C9.36286 2.45166 9.7 3.26559 9.7 4.11429V6.47619" stroke-width="1.06667" stroke="black"/></svg>';
  var started = false;
  var upcartRoot = null;

  // Keeps the original casing: Free -> Fast, FREE -> FAST, free -> fast
  function toFast(text) {
    return text.replace(/\b(free)(\s+shipping)/gi, function (match, free, rest) {
      var fast = free === "FREE" ? "FAST" : free.charAt(0) === "F" ? "Fast" : "fast";
      return fast + rest;
    });
  }

  function swapNode(node) {
    if (!/free\s+shipping/i.test(node.nodeValue)) return;
    var tag = node.parentNode && node.parentNode.nodeName;
    if (tag === "SCRIPT" || tag === "STYLE" || tag === "TEXTAREA") return;
    node.nodeValue = toFast(node.nodeValue);
  }

  function swapText(root) {
    if (root.nodeType === 3) return swapNode(root);
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) swapNode(node);
  }

  function swapRecords(records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].type === "characterData") swapText(records[i].target);
      for (var j = 0; j < records[i].addedNodes.length; j++) swapText(records[i].addedNodes[j]);
    }
  }

  function addPdpNote() {
    var buttons = document.querySelectorAll("gp-product-button");
    for (var i = 0; i < buttons.length; i++) {
      var next = buttons[i].nextElementSibling;
      if (!buttons[i].querySelector(".gp-button-atc")) continue;
      if (next && next.classList.contains("c-wood-site-07-pdp-note")) continue;
      buttons[i].insertAdjacentHTML("afterend", '<div class="c-wood-site-07-pdp-note">' + NOTE + "</div>");
    }
  }

  function patchUpcart(root) {
    if (!root.querySelector(".c-wood-site-07-style")) {
      var css = document.querySelector('link[href*="c-wood-site-07.css"]');
      if (css) {
        var link = css.cloneNode();
        link.classList.add("c-wood-site-07-style");
        root.appendChild(link);
      }
    }

    // UpCart re-renders its footer when the cart changes and can leave our nodes out of place
    // (e.g. the note ends up above the button), so put them back next to their anchors every time
    var checkout = root.querySelector(".upcart-checkout-button-container");
    if (checkout) {
      var note = root.querySelector(".c-wood-site-07-cart-note");
      if (!note) {
        // div, not p: UpCart's stylesheet zeroes p margins with !important
        note = document.createElement("div");
        note.className = "c-wood-site-07-cart-note";
        note.textContent = NOTE;
      }
      if (checkout.nextElementSibling !== note) checkout.after(note);
    }

    var badge = root.querySelector(".upcart-trust-badge");
    if (badge) {
      var strip = root.querySelector(".c-wood-site-07-cart-badge");
      if (!strip) {
        strip = document.createElement("div");
        strip.className = "c-wood-site-07-cart-badge";
        strip.innerHTML = LOCK_ICON + "<span>Lifetime guarantee + Fast shipping</span>";
      }
      if (badge.previousElementSibling !== strip) badge.before(strip);
    }
  }

  function watchUpcart() {
    var host = document.getElementById("upCart");
    var root = host && host.shadowRoot;
    if (!root || root === upcartRoot) return;
    upcartRoot = root;
    swapText(root);
    patchUpcart(root);
    new MutationObserver(function (records) {
      swapRecords(records);
      patchUpcart(root);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    if (started || !document.body.classList.contains("c-woodSite07VarA")) return;
    started = true;

    swapText(document.body);
    addPdpNote();
    watchUpcart();

    new MutationObserver(function (records) {
      swapRecords(records);
      addPdpNote();
      watchUpcart();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });

    // UpCart attaches its shadow root on its own schedule, which the body observer can't see
    var tries = 0;
    (function poll() {
      watchUpcart();
      if (!upcartRoot && tries++ < 40) setTimeout(poll, 500);
    })();
  }

  document.addEventListener("c:experiments-applied", init);
  init();
})();
